import { XCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { getUserFriendlyErrorMessage } from '@/lib/nmi';

interface PaymentErrorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  errorCode: string;
}

export function PaymentErrorDialog({ open, onOpenChange, errorCode }: PaymentErrorDialogProps) {
  const errorMessage = getUserFriendlyErrorMessage(errorCode);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle className="sr-only">Payment Error</DialogTitle>
        <div className="flex flex-col items-center space-y-4 p-2">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <XCircle className="h-8 w-8 text-red-600" />
          </div>
          
          <div className="text-center space-y-2">
            <h2 className="text-2xl font-semibold text-gray-900">
              Payment Failed
            </h2>
            <p className="text-gray-600 text-lg">
              {errorMessage}
            </p>
          </div>

          <Button 
            onClick={() => onOpenChange(false)}
            className="w-full bg-gray-600 hover:bg-gray-700 text-white mt-4 py-6 text-lg font-medium"
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
} 
